module.exports = __webpack_public_path__ + "img/sight_pin_selected.a3cf3d44.png";